import React from "react";

import PalamoaInputField from "./PalamoaInputField";
import PalamToggleSwitch from "../../generic/palam_toggle_switch";

class GeneralFormRow extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { focused: false };
  }

  renderInput() {
    let {
      value = "",
      onChange,
      onClear,
      type = "numeric",
      options = []
    } = this.props;
    let rv = null;


    switch (type) {
      case "string":
      case "numeric":
        rv = (
          <PalamoaInputField
            value={value}
            method="manual"
            isFocused={this.state.focused}
            onChange={onChange}
            onFocus={() => {
              this.setState({ focused: true });
            }}
            onBlur={() => {
              this.setState({ focused: false });
            }}
            onClear={onClear}
          />
        );
        break;
      case "bool":
        rv = (
          <PalamToggleSwitch
            isActive={value}
            onClick={() => {
                onChange({target:{value: !value}})
            }}
          />
        );
        break;

      case "select":
      console.log("XX", type, value)

        rv = (
          <select value={value} onChange={onChange}>
            {options.map((optionName, idx) => {
              return <option value={idx.toString()}>{optionName}</option>
            })}
            
          </select>
        );
        break;

      default:
        break;
    }
    return rv;
  }

  render() {
    let {
      label = "",
    } = this.props;

    return (
      <div className="configpane-form-row">
        <div className="configpane-form-row-label">{label}</div>
        <div className="configpane-form-row-input short">
          {this.renderInput.bind(this)()}
        </div>
      </div>
    );
  }
}

export default GeneralFormRow;
